function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _flattenDeep from 'lodash/flattenDeep';
import _uniq from 'lodash/uniq';
import _difference from 'lodash/difference';
import _compact from 'lodash/compact';
/**
 * Functions all exported for testing purposes.
 * Functions used in components: getNodeArrayByType, removeNodeArrayByType
 */

export var iterate = function iterate(nodes, applyToChildren) {
  var ancestors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return nodes.map(function (node) {
    var childAncestors = [node.value].concat(_toConsumableArray(ancestors));
    return {
      value: node.value,
      ancestors: applyToChildren ? ancestors : null,
      children: Object.prototype.hasOwnProperty.call(node, 'children') && Array.isArray(node.children) ? iterate(node.children, applyToChildren, childAncestors) : null
    };
  });
};
export var deepSelect = function deepSelect(nodes, value) {
  if (Array.isArray(nodes)) {
    return _flattenDeep(nodes.map( // eslint-disable-next-line no-confusing-arrow
    function (node) {
      return Object.prototype.hasOwnProperty.call(node, 'children') && Array.isArray(node.children) ? [node[value], deepSelect(node.children, value)] : node[value];
    }));
  } else return [];
};
export var mapTypedValues = function mapTypedValues(nodes, typedArray) {
  var flattenedData = typedArray;
  var structuredData = [];

  var flattenData = function flattenData(node) {
    var value = node.value,
        children = node.children;

    if (Array.isArray(children)) {
      children.forEach(flattenData);
      var childValues = deepSelect(children, 'value');

      if (typedArray.includes(value)) {
        flattenedData = [value].concat(_toConsumableArray(childValues), _toConsumableArray(flattenedData.filter(function (data) {
          return data !== value;
        })));
      } else if (_difference(childValues, flattenedData).length < 1) {
        flattenedData = [value].concat(_toConsumableArray(flattenedData));
      }

      return flattenedData;
    } else return null;
  };

  var structureData = function structureData(node) {
    var value = node.value,
        children = node.children;

    if (flattenedData.includes(value)) {
      structuredData = [].concat(_toConsumableArray(structuredData), [node]);
      return structuredData;
    } else if (Array.isArray(children)) {
      return children.map(structureData);
    } else return structuredData;
  };

  nodes.forEach(structureData);
  nodes.forEach(flattenData);
  return {
    structured: structuredData,
    flattened: _uniq(flattenedData)
  };
};
export var recursiveRemove = function recursiveRemove(nodes, typedArray, remove) {
  var selected = remove;

  var removeNodes = function removeNodes(node) {
    var value = node.value,
        ancestors = node.ancestors,
        children = node.children;

    if (Array.isArray(children)) {
      children.forEach(removeNodes);
    }

    var childValues = Array.isArray(children) ? deepSelect(children, 'value') : [null];

    if (remove.includes(value)) {
      selected = [value].concat(_toConsumableArray(childValues), _toConsumableArray(ancestors), _toConsumableArray(selected));
    }
  };

  nodes.forEach(removeNodes);

  var removedArray = _uniq(_difference(typedArray, selected));

  var structuredData = [];

  var structureData = function structureData(node) {
    var value = node.value,
        children = node.children;

    if (removedArray.includes(value)) {
      structuredData = [].concat(_toConsumableArray(structuredData), [node]);
      return structuredData;
    } else if (Array.isArray(children)) {
      return children.map(structureData);
    } else return structuredData;
  };

  nodes.forEach(structureData);
  return {
    structured: structuredData,
    flattened: removedArray
  };
};
export var getNodesByType = function getNodesByType(nodes, typedArray, applyToChildren) {
  return mapTypedValues(iterate(nodes, applyToChildren, []), typedArray);
};
export var removeNodesByType = function removeNodesByType(nodes, typedArray, remove, applyToChildren) {
  return recursiveRemove(iterate(nodes, applyToChildren, []), typedArray, remove);
};
export var getNodeArrayByType = function getNodeArrayByType(_ref) {
  var nodes = _ref.nodes,
      typedArray = _ref.typedArray,
      applyToChildren = _ref.applyToChildren;

  var _getNodesByType = getNodesByType(nodes, typedArray, applyToChildren),
      structured = _getNodesByType.structured,
      flattened = _getNodesByType.flattened;

  return {
    nodes: structured,
    array: _compact(flattened)
  };
};
export var removeNodeArrayByType = function removeNodeArrayByType(_ref2) {
  var nodes = _ref2.nodes,
      typedArray = _ref2.typedArray,
      remove = _ref2.remove,
      applyToChildren = _ref2.applyToChildren;

  var _removeNodesByType = removeNodesByType(nodes, typedArray, remove, applyToChildren),
      structured = _removeNodesByType.structured,
      flattened = _removeNodesByType.flattened;

  return {
    nodes: structured,
    array: _compact(flattened)
  };
};